var _defs, _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _g4, _path9, _path0, _g5, _path1, _g6, _path10, _path11, _g7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItunesStore(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0linear3042042",
    x1: 11.9998,
    y1: 0.978433,
    x2: 11.9998,
    y2: 22.9787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF4DB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C643FD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1radial3042042",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.48822 15.9028) scale(0.0228127)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9E3FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7459,
    stopColor: "#F9E3FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8097,
    stopColor: "#F8DEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8826,
    stopColor: "#F3D0FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9599,
    stopColor: "#ECBAF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#EAB2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAB2F9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2radial3042042",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-6.64628 0.976766) scale(0.0229896)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAE1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FAE1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#F7D6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7D6F7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3radial3042042",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.3815 24.3827) scale(0.0228127)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAE9FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#FAE9FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8118,
    stopColor: "#F8DEFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#F6D4F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6D4F8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4radial3042042",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.3807 24.3821) scale(0.0229896)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAE9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FAE9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8132,
    stopColor: "#F8DEF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#F5CAF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5CAF2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5radial3042042",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.48795 15.9013) scale(0.0229239)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBE3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    stopColor: "#FBE3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8082,
    stopColor: "#FADEF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8798,
    stopColor: "#F9D1F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9554,
    stopColor: "#F6BAE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#F5B1E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B1E3"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask03042042",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 1H1V23H23V1Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask03042042)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13042042",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 22
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74928 1C7.53036 1 7.31231 1 7.0934 1.00172C6.87276 1.00259 6.65126 1.00517 6.42976 1.0112C5.94711 1.02413 5.46102 1.05257 4.98355 1.1379C4.5009 1.22495 4.05015 1.36716 3.61059 1.59038C3.1788 1.81102 2.7832 2.09716 2.44104 2.44018C2.09802 2.7832 1.81188 3.17794 1.59124 3.60973C1.36716 4.04928 1.22581 4.50004 1.13876 4.98441C1.05344 5.46102 1.02499 5.94711 1.01207 6.42976C1.00603 6.65126 1.00345 6.8719 1.00259 7.0934C1 7.30455 1 7.51485 1 7.72601V7.882V16.1189V16.2749C1 16.4852 1 16.6963 1.00172 16.9066C1.00345 17.1281 1.00517 17.3487 1.0112 17.5702C1.02413 18.052 1.05257 18.5381 1.1379 19.0156C1.22409 19.5 1.36716 19.9499 1.59038 20.3903C1.81102 20.8221 2.09716 21.2177 2.44018 21.5598C2.7832 21.902 3.17794 22.1898 3.60973 22.4096C4.04928 22.6337 4.50004 22.7751 4.98355 22.8621C5.46016 22.9474 5.94711 22.9767 6.4289 22.9888C6.6504 22.9948 6.87103 22.9974 7.09253 22.9983C7.31145 23 7.5295 23 7.74841 23H7.88114H16.118H16.2507C16.4696 23 16.6877 23 16.9066 22.9983C17.1281 22.9966 17.3487 22.9948 17.5702 22.9888C18.0529 22.9759 18.539 22.9474 19.0156 22.8621C19.4991 22.7759 19.949 22.6328 20.3894 22.4096C20.8212 22.189 21.2168 21.9028 21.559 21.5598C21.902 21.2168 22.189 20.8221 22.4088 20.3903C22.6328 19.9507 22.7742 19.5 22.8612 19.0156C22.9466 18.539 22.975 18.0529 22.9879 17.5702C22.994 17.3487 22.9966 17.1281 22.9974 16.9066C22.9983 16.6963 22.9991 16.4843 22.9991 16.274V7.72773C22.9991 7.51743 22.9991 7.30541 22.9974 7.09512C22.9957 6.87362 22.994 6.65298 22.9879 6.43148C22.975 5.9497 22.9466 5.46361 22.8612 4.98613C22.7751 4.50176 22.632 4.05187 22.4088 3.61146C22.1881 3.17966 21.902 2.78406 21.559 2.4419C21.2159 2.09888 20.8212 1.81188 20.3894 1.5921C19.9499 1.36802 19.4991 1.22667 19.0156 1.13962C18.539 1.0543 18.052 1.02499 17.5702 1.01293C17.3487 1.00689 17.1281 1.00431 16.9066 1.00345C16.6877 1.00172 16.4696 1.00172 16.2507 1.00172H7.74928V1Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13042042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 1H1V23H23V1Z",
    fill: "url(#paint0linear3042042)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23042042",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 22
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 1H1V23H23V1Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23042042)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask33042042",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 13,
    width: 7,
    height: 7
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9951 15.9059L15.8442 18.7018C16.0476 18.8501 16.2562 18.9931 16.4682 19.1302C16.5406 19.1776 16.6173 19.2163 16.6992 19.2448C16.7087 19.2482 16.7181 19.2508 16.7285 19.2543C16.788 19.2715 16.8414 19.2793 16.8931 19.2758C16.9431 19.2715 16.9879 19.2569 17.0232 19.2293C17.0603 19.2034 17.0879 19.1655 17.1068 19.119C17.1258 19.0716 17.1353 19.0181 17.1379 18.9561C17.1379 18.9457 17.1379 18.9362 17.1379 18.925C17.137 18.8388 17.1232 18.7535 17.1 18.6699C17.0353 18.426 16.9638 18.1838 16.8853 17.9442L15.415 13.4194L11.9951 15.9059Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33042042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1379 13.4214H11.9951V19.2804H17.1379V13.4214Z",
    fill: "url(#paint1radial3042042)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask43042042",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 22
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23 1H1V23H23V1Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43042042)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask53042042",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 9,
    width: 7,
    height: 5
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1233 9.40063C4.87163 9.40063 4.6191 9.40753 4.36744 9.42046C4.28211 9.42477 4.19593 9.43769 4.11319 9.46441C4.10285 9.467 4.09336 9.47045 4.08388 9.47389C4.02528 9.49458 3.97701 9.51957 3.93823 9.55319C3.90031 9.58507 3.87359 9.62386 3.8598 9.66695C3.84601 9.71004 3.84515 9.75572 3.85635 9.80485C3.86842 9.85484 3.89255 9.90396 3.92702 9.95395C3.93306 9.96257 3.93823 9.97033 3.94512 9.97895C3.99684 10.0479 4.05803 10.1091 4.12525 10.1634C4.3209 10.3228 4.52171 10.4762 4.72511 10.6245L8.57335 13.4212L9.87994 9.40063H5.1233Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53042042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.88038 9.40063H3.84473V13.4212H9.88038V9.40063Z",
    fill: "url(#paint2radial3042042)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask63042042",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 22
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23 1H1V23H23V1Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63042042)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask73042042",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 13,
    width: 6,
    height: 7
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.10507 17.946C7.0275 18.1856 6.95596 18.4277 6.89046 18.6716C6.86891 18.7544 6.85426 18.8406 6.85254 18.9268C6.85254 18.9371 6.85254 18.9474 6.85254 18.9578C6.85426 19.0198 6.86288 19.0733 6.88357 19.1207C6.90253 19.1672 6.93097 19.2043 6.96717 19.231C7.00337 19.2577 7.04732 19.2732 7.09731 19.2775C7.14816 19.2818 7.20246 19.2741 7.26193 19.256C7.27141 19.2534 7.28089 19.25 7.29123 19.2465C7.37224 19.2189 7.45067 19.1793 7.52221 19.1319C7.73337 18.9948 7.94194 18.8518 8.14534 18.7035L11.9944 15.9068L9.82339 14.3296L8.57455 13.4194L7.10507 17.946Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask73042042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9953 13.4214H6.85254V19.2804H11.9953V13.4214Z",
    fill: "url(#paint3radial3042042)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask83042042",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 22
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23 1H1V23H23V1Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask83042042)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask93042042",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 9,
    width: 7,
    height: 5
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1094 9.40063L15.416 13.4212L19.2651 10.6245C19.4685 10.4762 19.6693 10.3228 19.8649 10.1634C19.9321 10.1091 19.9933 10.0479 20.045 9.97895C20.0511 9.97033 20.0571 9.96257 20.0631 9.95395C20.0985 9.9031 20.1226 9.85484 20.1338 9.80485C20.145 9.75572 20.1442 9.70918 20.1304 9.66695C20.1166 9.62386 20.0899 9.58594 20.0519 9.55319C20.0132 9.51957 19.964 9.49458 19.9072 9.47389C19.8968 9.47045 19.8873 9.467 19.8778 9.46441C19.796 9.43942 19.7098 9.42649 19.6236 9.42132C19.3719 9.40667 19.1203 9.40063 18.8669 9.40063H14.1094Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask93042042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1449 9.39966H14.1084V13.4203H20.1449V9.39966Z",
    fill: "url(#paint4radial3042042)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask103042042",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 22
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M23 1H1V23H23V1Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask103042042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.88179 9.40063L8.5752 13.4212L9.8249 14.3288L11.9959 15.906L15.4167 13.4212L14.1101 9.40063H9.88179Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask113042042",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 22
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23 1H1V23H23V1Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask113042042)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask123042042",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 3,
    width: 6,
    height: 7
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8624 3.79587C11.8184 3.82259 11.7805 3.86051 11.7426 3.90964C11.7366 3.91739 11.7305 3.92601 11.7245 3.93377C11.6745 4.00444 11.6349 4.08201 11.6047 4.16216C11.5133 4.39745 11.4297 4.63533 11.3522 4.87493L9.88184 9.40059H14.1102L12.6389 4.87493C12.5614 4.63533 12.4761 4.39745 12.3864 4.16216C12.3554 4.08201 12.3157 4.00358 12.2666 3.93377C12.2606 3.92515 12.2546 3.91739 12.2485 3.90964C12.2106 3.86051 12.1718 3.82173 12.1279 3.79587C12.0848 3.77002 12.0408 3.75623 11.9951 3.75623C11.9495 3.75623 11.9055 3.76915 11.8624 3.79587Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask123042042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1092 3.75623H9.88086V9.40059H14.1092V3.75623Z",
    fill: "url(#paint5radial3042042)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItunesStore);
export default __webpack_public_path__ + "static/media/itunes-store.a7a47b72.svg";
export { ForwardRef as ReactComponent };